import { keys } from "../strings";

const DEBUG_FLAGS_EVENT = "finanslicenser-debug-flags-changed";

function isLevelCompletionAnimationDebugAllowed(): boolean {
  const env = process.env.NODE_ENV;
  return env === "development" || env === "test";
}

/**
 * Preview the level-close + snake progress animation without persisting progress.
 * Dev-only: ignored in production builds even if localStorage is set.
 */
export function readLevelCompletionAnimationDebugFlag(): boolean {
  if (!isLevelCompletionAnimationDebugAllowed()) {
    return false;
  }
  if (typeof window === "undefined") {
    return false;
  }
  try {
    return (
      window.localStorage.getItem(
        keys.localStorage.levelCompletionAnimationDebug
      ) === "true"
    );
  } catch {
    return false;
  }
}

export function writeLevelCompletionAnimationDebugFlag(enabled: boolean): void {
  if (!isLevelCompletionAnimationDebugAllowed()) {
    return;
  }
  if (typeof window === "undefined") {
    return;
  }
  try {
    if (enabled) {
      window.localStorage.setItem(
        keys.localStorage.levelCompletionAnimationDebug,
        "true"
      );
    } else {
      window.localStorage.removeItem(
        keys.localStorage.levelCompletionAnimationDebug
      );
    }
    window.dispatchEvent(new Event(DEBUG_FLAGS_EVENT));
  } catch {
    /* ignore quota / private mode */
  }
}

export function subscribeLevelCompletionAnimationDebugFlag(
  listener: () => void
): () => void {
  if (typeof window === "undefined") {
    return () => undefined;
  }
  window.addEventListener(DEBUG_FLAGS_EVENT, listener);
  window.addEventListener("storage", listener);
  return () => {
    window.removeEventListener(DEBUG_FLAGS_EVENT, listener);
    window.removeEventListener("storage", listener);
  };
}
